// extracted by mini-css-extract-plugin
export default {"UserInfoWrapper":"UserMenu_UserInfoWrapper__zzCtU"};